import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useFulfillmentNavigation } from "../../../workspaces/supply/navigation";
export const Route = createFileRoute("/_console/p/$org/$project/supply")({ component: SupplyLayout });
function SupplyLayout() {
  useFulfillmentNavigation("supply");
  return <Outlet />;
}
